export default {
  /**
   * KEY_MAP is setting for key google maps, so each server use different key maps.
   * link for generate KEY Maps= https://developers.google.com/maps/documentation/javascript/get-api-key
   */

  /* Local Development */
  "KEY_MAP" : "AIzaSyDj6ELHNa63MzOTdo5VrzBFzOjkwmuwXaU",

  /* Server Dev */
  "KEY_MAP_DEV" : "AIzaSyDfSc8_wmaIIK6nVhOj0upHsneMVuCNDls",

  /* Server Demo */
  "KEY_MAP_DEMO" : "AIzaSyBNOTdM6AAAusFUi3Uac8m0B8OR06QnYFU",

  /* Server Production */
  "KEY_MAP_PRODUCTION" : "AIzaSyDJAqpB2xEsCHNEpzD91yhoD6WVdIdsaIk",
}



// WEBPACK FOOTER //
// ./src/App/config/config.js